<template>
<div id="details-right">
  <div class="columns">
    <div class="column">
      <p class="el-p">X</p>
      <p class="el-p">Y</p>
      <p class="el-p">delta_x</p>
      <p class="el-p">delta_y</p>
    </div>
    <div class="column">
      <p class="el-p">{{ x }}</p>
      <p class="el-p">{{y}}</p>
      <p class="el-p">{{ directionX }}</p>
      <p class="el-p">{{directionY}}</p>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'detailsRight',
  data() {
    return {
      x: 0,
      y: 0,
      directionY: 0.0,
      directionX: 0.0,
      timestamp: null
    }
  },

  methods: {
    logMouse(e) {
      this.x = e.pageX
      this.y = e.pageY
      this.directionX = e.movementX || e.mozMovementX || e.webkitMovementX || 0;
      this.directionY = e.movementY || e.mozMovementY || e.webkitMovementY || 0;

    }
  },
  created() {
    var self = this;
    window.addEventListener('mousemove', self.logMouse);

  },
  destroyed() {
    window.removeEventListener('mousemove', self.logMouse);
  },
  mounted() {}
}
</script>

<style>
#details-right {
  position: fixed;
  pointer-events: none;
  user-select: none;
  right: 0;
  bottom: 0;
  padding: 2em;
  font-size: 0.7em;
  z-index: 2;
  /* width: 20vw; */
}
</style>
